import React, { useState, useEffect, useMemo } from "react";
import { Checkbox, ListItemText, MenuItem } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import useFetch from "../../../hooks/useFetch";
import referentialAPI from "../../../_api/_referentialAPI";
import FilterPopoverContainer from "../../common/chip_filter/FilterPopoverContainer";
import BottomFilterContent from "../../common/chip_filter/BottomFilterContent";

const WorkStudyLevelFilter = ({ preSelected, onChange }: any) => {
  const { t } = useTranslation("common");
  const theme: any = useTheme();
  const [value, setValue] = useState<string[]>(preSelected ?? []);
  const [list, setList] = useState<any>([]);
  const [close, setClose] = useState<any>(false);

  const { data } = useFetch(referentialAPI.get({ type: "studyLevel" }));

  useEffect(() => {
    setValue((preSelected ?? []).map((el: string | number) => `${el}`));
  }, [preSelected]);

  const chipTitle = useMemo(() => {
    const names = value.map(
      (val: string) => list?.find((item: any) => item.code === val)?.label
    );

    const first = `${names?.[0]}`;
    const second = `${names?.[1]}`;
    return names?.length > 2
      ? `${first}, ${second} +${names?.length - 2}`
      : names?.length > 1
      ? `${first}, ${second}`
      : names?.length > 0
      ? `${first}`
      : t("experience_section.form.study_level");
  }, [list, t, value]);

  const handleChange = (newValue: any) => {
    console.log("newValue", newValue);
    setValue((prev: string[]) => {
      let arr = [...prev];

      if (arr.find((el) => el === newValue)) {
        arr = arr.filter((el) => el !== newValue);
      } else {
        arr = [...arr, newValue];
      }

      return arr;
    });
  };

  useEffect(() => {
    data?.["hydra:member"] &&
      setList(
        data?.["hydra:member"]?.sort((a: any, b: any) => a?.code - b?.code)
      );
  }, [data]);

  const handleSubmit = () => {
    onChange(value);
    setClose(!close);
  };

  const handleClear = () => {
    onChange([]);
    setValue([]);
    setClose(!close);
  };

  return (
    <>
      <FilterPopoverContainer
        title={chipTitle}
        idPop="work_study_popover"
        close={close}
        active={value?.length > 0}
        content={
          <>
            {list?.map((item: any) => (
              <MenuItem
                sx={{
                  backgroundColor:
                    value.indexOf(item.code) > -1 && theme.palette.primary[100],
                }}
                onClick={() => handleChange(item?.code)}
                key={item.id}
                value={item.label}
              >
                <Checkbox checked={value.indexOf(item.code) > -1} />
                <ListItemText primary={t(item.label)} />
              </MenuItem>
            ))}
            <BottomFilterContent
              handleSubmit={handleSubmit}
              handleClear={handleClear}
              disabled={value?.length === 0}
            />
          </>
        }
      />
    </>
  );
};

export default WorkStudyLevelFilter;
